import { render, staticRenderFns } from "./GlassBreakageDamageTypeQuestion.vue?vue&type=template&id=029a6f4e&scoped=true"
import script from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageDamageTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageDamageTypeQuestion.vue?vue&type=style&index=0&id=029a6f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a6f4e",
  null
  
)

export default component.exports